import { type ModuleRegisterFunction } from "@sg-protect/shell";
import { registerReviewsI18next } from "./i18n/i18next.ts";

export const registerDelegatedReviews: ModuleRegisterFunction = async runtime => {
    await registerReviewsI18next(runtime);

    if (runtime.isMswEnabled) {
        const { handlers } = await import("./api/msw.ts");
        const { registerLoginRoutes } = await import("./features/login/register.tsx");

        // Tags handlers so DUMP_MSW_MOCKS=true (pnpm dev-msw:dump) can report which module each mock came from.
        handlers.forEach(handler => Object.assign(handler, { mockModule: "reviews" }));

        runtime.registerRequestHandlers(handlers);
        registerLoginRoutes(runtime);
    }

    const { registerRoutes } = await import("./routes.tsx");

    registerRoutes(runtime);
};
